export const ETC_MISSION_CATALOG = [
  {
    type: 'follow_on_daangn',
    channel: 'follow_on',
    product: '_daangn',
    channelLabel: '당근',
    productLabel: '단골 맺기',
  },
  {
    type: 'yanolja_wish',
    channel: 'yanolja',
    product: '_wish',
    channelLabel: '야놀자',
    productLabel: '찜하기',
  },
  {
    type: 'catchtable_save',
    channel: 'catchtable',
    product: '_save',
    channelLabel: '캐치테이블',
    productLabel: '저장하기',
  },
  {
    type: 'kakao_channel_add',
    channel: 'kakao_channel',
    product: '_add',
    channelLabel: '카카오 채널',
    productLabel: '추가하기',
  },
  {
    type: 'blog_post_like',
    channel: 'blog_post',
    product: '_like',
    channelLabel: '블로그 포스팅',
    productLabel: '공감하기',
  },
  {
    type: 'blog_post_keep',
    channel: 'blog_post',
    product: '_keep',
    channelLabel: '블로그 포스팅',
    productLabel: '킵하기',
  },
];

export const CHANNEL_OPTIONS = [
  { value: '전체', label: '전체' },
  ...Array.from(
    new Map(
      ETC_MISSION_CATALOG.map(item => [item.channelLabel, item])
    ).values()
  ).map(item => ({ value: item.channelLabel, label: item.channelLabel })),
];

export const PRODUCT_OPTIONS = [
  { value: '전체', label: '전체' },
  ...Array.from(
    new Map(
      ETC_MISSION_CATALOG.map(item => [item.productLabel, item])
    ).values()
  ).map(item => ({ value: item.productLabel, label: item.productLabel })),
];

export const ALL_ETC_TYPES = ETC_MISSION_CATALOG.map(item => item.type);

export function channelProductToTypes(channelLabels, productLabels) {
  const isChannelAll = !channelLabels || channelLabels.length === 0 || channelLabels.includes('전체');
  const isProductAll = !productLabels || productLabels.length === 0 || productLabels.includes('전체');

  if (isChannelAll && isProductAll) {
    return ALL_ETC_TYPES;
  }

  const filteredChannelLabels = !isChannelAll ? channelLabels : [];
  const filteredProductLabels = !isProductAll ? productLabels : [];

  return ETC_MISSION_CATALOG.filter(item => {
    const matchChannel = isChannelAll || filteredChannelLabels.includes(item.channelLabel);
    const matchProduct = isProductAll || filteredProductLabels.includes(item.productLabel);
    return matchChannel && matchProduct;
  }).map(item => item.type);
}

export function getCampaignTypeLabel(campaignType) {
  const item = ETC_MISSION_CATALOG.find(cat => cat.type === campaignType);
  if (item) {
    return {
      channelLabel: item.channelLabel,
      productLabel: item.productLabel,
    };
  }
  return {
    channelLabel: campaignType,
    productLabel: '',
  };
}
